export default {
    common: {
        actions: {
            add: 'Dodaj',
            edit: 'Uredi',
            save: 'Spremi',
            cancel: 'Odustani',
            delete: 'Obriši',
            close: 'Zatvori',
            search: 'Pretraži',
            filter: 'Filtriraj',
            export: 'Izvezi',
            back: 'Natrag',
            confirm: 'Potvrdi',
            refresh: 'Osvježi',
            download: 'Preuzmi',
            retry: 'Pokušaj ponovno',
            generate: 'Generiraj',
        },
        labels: {
            date: 'Datum',
            status: 'Status',
            actions: 'Radnje',
            type: 'Vrsta',
            all: 'Sve',
            total: 'Ukupno',
            name: 'Naziv',
        },
        status: {
            active: 'Aktivno',
            inactive: 'Neaktivno',
            pending: 'Na čekanju',
        },
        messages: {
            loading: 'Učitavanje…',
            noData: 'Nema podataka',
            error: 'Došlo je do pogreške',
            success: 'Uspješno',
        },
    },
    settings: {
        title: 'Postavke',
        language: 'Jezik',
        languageHint: 'Odaberite željeni jezik',
    },
}
